import {DefaultTooltipStaticPropsType} from '../../../../component/chart-tooltip/default-chart-tooltip';
import {barChartOptions} from '../../../../layout/chart/bar-chart/bar-chart-helper';
import {ChartJsBarOptionsType} from '../../../../layout/chart/bar-chart/bar-chart-type';
import {getDefaultReactTooltipOptions} from '../../../../layout/chart/chart-const';
import {LangKeyType} from '../../../../provider/locale/translation/type';
import {ActionDynamicsEnum} from '../../../../service/online-presence/online-presence-type';

import * as styles from './target-actions-dynamics.scss';

export const targetActionsLangKeyMap: Record<ActionDynamicsEnum, LangKeyType> = {
    [ActionDynamicsEnum.CallClicks]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS__CALLS',
    [ActionDynamicsEnum.WebsiteClicks]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS__SITE',
    [ActionDynamicsEnum.DirectRequests]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS__ROUTES',
    [ActionDynamicsEnum.CallToAction]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS__CALLS_TO_ACTION',
    [ActionDynamicsEnum.OpenSocial]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__OPEN_SOCIALS',
    [ActionDynamicsEnum.PhotoClicks]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__PHOTO_CLICKS',
    [ActionDynamicsEnum.Stories]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__STORIES_CLICKS',
    [ActionDynamicsEnum.Other]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS__OTHER',

    [ActionDynamicsEnum.Wechat]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__WECHAT',
    [ActionDynamicsEnum.Telegram]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__TELEGRAM',
    [ActionDynamicsEnum.Viber]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__VIBER',
    [ActionDynamicsEnum.Whatsapp]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__WHATSAPP',

    [ActionDynamicsEnum.PhotoViews]:
        'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__DEEP_CLICKS__PHOTO_VIEWS',
    [ActionDynamicsEnum.Phone]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__DEEP_CLICKS__PHONE',
    [ActionDynamicsEnum.Review]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__DEEP_CLICKS__REVIEW',
    [ActionDynamicsEnum.WorkingStatus]:
        'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__DEEP_CLICKS__WORKING_STATUS',
    [ActionDynamicsEnum.Entrances]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__DEEP_CLICKS__ENTRANCES',
    [ActionDynamicsEnum.Discovery]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__DEEP_CLICKS__DISCOVERY',
    [ActionDynamicsEnum.NotDiscovery]:
        'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__DEEP_CLICKS__NOT_DISCOVERY',
};

export const targetActionsTableLangKeyMap: Record<ActionDynamicsEnum, LangKeyType> = {
    [ActionDynamicsEnum.CallClicks]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__CALLS',
    [ActionDynamicsEnum.WebsiteClicks]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__SITE',
    [ActionDynamicsEnum.DirectRequests]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__ROUTES',
    [ActionDynamicsEnum.CallToAction]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__CALLS_TO_ACTION',
    [ActionDynamicsEnum.OpenSocial]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__OPEN_SOCIALS',
    [ActionDynamicsEnum.PhotoClicks]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__PHOTO_CLICKS',
    [ActionDynamicsEnum.Stories]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__STORIES_CLICKS',
    [ActionDynamicsEnum.Other]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__OTHER',

    [ActionDynamicsEnum.Wechat]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__WECHAT',
    [ActionDynamicsEnum.Telegram]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__TELEGRAM',
    [ActionDynamicsEnum.Viber]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__VIBER',
    [ActionDynamicsEnum.Whatsapp]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__WHATSAPP',

    [ActionDynamicsEnum.PhotoViews]:
        'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__DEEP_CLICKS__PHOTO_VIEWS',
    [ActionDynamicsEnum.Phone]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__DEEP_CLICKS__PHONE',
    [ActionDynamicsEnum.Review]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__DEEP_CLICKS__REVIEW',
    [ActionDynamicsEnum.WorkingStatus]:
        'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__DEEP_CLICKS__WORKING_STATUS',
    [ActionDynamicsEnum.Entrances]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__DEEP_CLICKS__ENTRANCES',
    [ActionDynamicsEnum.Discovery]: 'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__DEEP_CLICKS__DISCOVERY',
    [ActionDynamicsEnum.NotDiscovery]:
        'ONLINE_PRESENCE_ANALYTICS__TARGET_ACTION_DYNAMICS_TABLE__DEEP_CLICKS__NOT_DISCOVERY',
};

export const targetActionsColorMap: Record<ActionDynamicsEnum, string> = {
    [ActionDynamicsEnum.CallClicks]: styles.callClicksChartColor,
    [ActionDynamicsEnum.WebsiteClicks]: styles.websiteClicksChartColor,
    [ActionDynamicsEnum.DirectRequests]: styles.directRequestsChartColor,
    [ActionDynamicsEnum.CallToAction]: styles.callsToActionChartColor,
    [ActionDynamicsEnum.OpenSocial]: styles.openSocialChartColor,
    [ActionDynamicsEnum.PhotoClicks]: styles.photoClicksChartColor,
    [ActionDynamicsEnum.Stories]: styles.stroriesChartColor,

    [ActionDynamicsEnum.PhotoViews]: styles.photoViewsChartColor,
    [ActionDynamicsEnum.Phone]: styles.phoneChartColor,
    [ActionDynamicsEnum.Review]: styles.reviewChartColor,
    [ActionDynamicsEnum.WorkingStatus]: styles.workingStatusChartColor,
    [ActionDynamicsEnum.Entrances]: styles.entrancesChartColor,
    [ActionDynamicsEnum.Other]: styles.otherChartColor,

    [ActionDynamicsEnum.Wechat]: styles.wechatChartColor,
    [ActionDynamicsEnum.Telegram]: styles.telegramChartColor,
    [ActionDynamicsEnum.Viber]: styles.viberChartColor,
    [ActionDynamicsEnum.Whatsapp]: styles.whatsappChartColor,

    [ActionDynamicsEnum.Discovery]: styles.discoveryChartColor,
    [ActionDynamicsEnum.NotDiscovery]: styles.notDiscoveryChartColor,
};

export function getTargetActionDynamicsChartOptions(options: {
    tooltipOptions: DefaultTooltipStaticPropsType;
    showTooltip?: boolean;
    disableAnimation: boolean;
}): ChartJsBarOptionsType {
    const {tooltipOptions, disableAnimation, showTooltip} = options;

    return {
        ...barChartOptions,
        ...(disableAnimation
            ? {
                  animation: false,
              }
            : {}),
        plugins: {
            ...barChartOptions.plugins,
            legend: {
                display: false,
            },
            tooltip: showTooltip ? getDefaultReactTooltipOptions(tooltipOptions) : {enabled: false},
            datalabels: {display: false},
        },
    };
}

function getTargetActionsDynamicsPriority(actionDynamics: ActionDynamicsEnum): number {
    return Object.values(ActionDynamicsEnum).indexOf(actionDynamics) + 1;
}

export function sortActionDynamicsValues(
    item1: {label: ActionDynamicsEnum},
    item2: {label: ActionDynamicsEnum}
): number {
    return getTargetActionsDynamicsPriority(item1.label) - getTargetActionsDynamicsPriority(item2.label);
}

export const yandexTargetActionsDetailsChartKeys: Array<ActionDynamicsEnum> = [
    ActionDynamicsEnum.Viber,
    ActionDynamicsEnum.Wechat,
    ActionDynamicsEnum.Telegram,
    ActionDynamicsEnum.Whatsapp,
];

export const yandexTargetActionsMainChartKeys: Array<ActionDynamicsEnum> = Object.values(ActionDynamicsEnum).filter(
    (actionDynamicsKey) => {
        return !yandexTargetActionsDetailsChartKeys.includes(actionDynamicsKey);
    }
);
